import { render } from "./LoginView.vue?vue&type=template&id=572095f0&ts=true"
import script from "./LoginView.vue?vue&type=script&lang=ts"
export * from "./LoginView.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\ulucefe\\source\\repos\\birimza.admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__